import api from "@/apis/system"

/**
 * 解释元数据名称
 * @param {string} type  数据类型
 * @param {string} value  数据编码
 * @returns 
 */
const format = (type, value) => {
    if (!type || !value) {
        return value
    }
    let options = items(type) || [];
    return options.find(x => x.value == value)?.text || value
}


/**
 * 获取数据字典
 */
let promise = Promise.resolve()
const items = (type) => {
    const key = `meta-${type}`
    promise = promise.then(() => {
        if (!localStorage.getItem(key)) {
            return api.meta.itemList({ typeId: type })
        }
    }).then(res => {
        if (res) {
            let dics = flatJson(res, 'children').map(element => {
                return {
                    text: element.Name,
                    value: element.Code
                }
            })
            localStorage.setItem(key, JSON.stringify(dics))
        }
    })

    return JSON.parse(localStorage.getItem(key))
}

/**
 * 树形结构扁平化
 * @param {*} data
 * @param {*} key
 */
function flatJson(data, key, pname = '') {
    let res = []
    data.forEach((row) => {
        row.Name = `${pname}${row.Name}`
        res.push(row)
        if (row[key]) {
            res = res.concat(flatJson(row[key], key, row.Name))
        }
    })
    return res
}

export default {
    items,
    format
}